var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn group-hover:bg-accent-yellow-darker",class:_vm.buttonClasses},[(_vm.active)?_c('span',[_vm._v(_vm._s(_vm.lang('Dölj', 'Hide')))]):_c('span',[_vm._v(_vm._s(_vm.lang('Visa', 'Show')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }